const mapJsonToProps = ({ message_type, body, closeable, hierarchy, className = '', bg_color }) => ({
  type: message_type,
  body,
  hierarchy,
  closeable,
  bgColor: bg_color,
  className: `ui-vpp-message ${className}`,
});

export default mapJsonToProps;
